<template>
  <div v-if="tableType == 'page'" class="switch-page">
    <span class="switch-page__prev" :class="{'disabled':pageNumber <= 1}" @click="pageNumber--">
      <img class="arrow-icon" src="../../assets/symbols/arrow-point-to-right.svg"/>
    </span>
    <span class="switch-page__current">
      <div class="form-group">
        <input class="form-control form-control-lg" type="text" v-model="pageNumber" @input="emitOnInput($event)"/>
      </div>
    </span>
    <span class="switch-page__next" :class="{'disabled':pageNumber >= pages.length}" @click="pageNumber++">
      <img class="arrow-icon" src="../../assets/symbols/arrow-point-to-right.svg"/>
    </span>
  </div>
</template>

<script>

import debounce from "lodash.debounce";
import draggable from 'vuedraggable';

export default {

  name: 'switchPage',
  props:{

    pageId:{
      type: Number,
      default: 0,
    },

    pages:{
      type: Array,
      default: () => [],
    },

    tableType: String,

  },
  data () {

    return {

      pageNumber: 0,
      currentPageId: 0,

    }

  },
  methods:{

    getPageNumber(){

      let obj = this.pages.find(o => o.id === this.pageId);
      
      if(obj){
        
        this.pageNumber = obj.number;
        return;

      }

      this.pageNumber = 0;

    },

    emitPageId(){

      let obj = this.pages.find(o => o.number === this.pageNumber);
      
      if(obj){
        
        this.currentPageId = obj.id;

        this.$emit('click', this.currentPageId);
        return;

      }

    },

    emitOnInput: debounce(function(e){

      if(e.target.value){

        if(e.target.value > 0 && e.target.value <= this.pages.length){

          let obj = this.pages.find(o => o.number === parseInt(e.target.value));
        
          if(obj){
            
            this.currentPageId = obj.id;

            this.$emit('input', parseInt(this.currentPageId));
            return;

          }

        }

      }

    }, 500),

  },
  watch:{

    pageId: function(){

      this.getPageNumber();

    },

    pageNumber: function(){

      this.emitPageId();

    },

  },
  mounted(){

    this.getPageNumber();

  },
};
</script>

<style lang="scss" scoped>

.switch-page{
  display:flex;
  justify-content: space-between;
  width:100%;
  padding:5px;
  position: absolute;
  bottom:0;
  left:0;

  &__prev, &__next{
    font-size: 24px;
    font-weight: 700;
    cursor:pointer;

    &.disabled{
      pointer-events: none;
    }
  }

  &__prev img{
    transform: rotate(180deg);
  }

  &__current{
    width:25px;

    & input{
      text-align: center;
      color:#d3020c;
    }
  }
}

.arrow-icon{
  display: block;
  width: 15px;
  opacity: 0.6;
}

</style>